var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreviewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8235",
    "data-name": "Group 8235",
    transform: "translate(-1663 -442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2000",
    "data-name": "Rectangle 2000",
    transform: "translate(1663 442)",
    fill: "#59a638",
    stroke: "#59a638",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 38,
    height: 38,
    rx: 6.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8233",
    "data-name": "Group 8233",
    transform: "translate(-4.661 -368.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15897",
    "data-name": "Path 15897",
    d: "M446.118,561.15a18.171,18.171,0,0,1,10.941,3.824c1.406,1.046,2.672,2.281,4.006,3.424a.559.559,0,0,1,.052.946,23.579,23.579,0,0,1-10.941,7,15.234,15.234,0,0,1-12.479-2.007,25.912,25.912,0,0,1-5.748-4.956c-.345-.39-.379-.663,0-1.066a21.433,21.433,0,0,1,11.754-6.934,5.205,5.205,0,0,1,.529-.076C444.959,561.243,445.692,561.185,446.118,561.15Zm.021,14.621a6.844,6.844,0,1,0-6.9-6.866A6.877,6.877,0,0,0,446.138,575.771Z",
    transform: "translate(1240.646 260.85)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15898",
    "data-name": "Path 15898",
    d: "M466.461,572.162a2.049,2.049,0,0,0-1.432,2.6,1.673,1.673,0,0,0,1.55,1.279c1.176.107,1.779-.61,2.084-1.678.9.971.568,3.239-.584,4.5a4.033,4.033,0,0,1-5.487.527,4.261,4.261,0,0,1-.991-5.682A3.839,3.839,0,0,1,466.461,572.162Z",
    transform: "translate(1221.825 254.406)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewIcon);
export default __webpack_public_path__ + "static/media/preview-icon.2e3b4717941c4ca316ef9a77dac79643.svg";
export { ForwardRef as ReactComponent };